export default [
  {
    id: `material`,
    title: `Описание`,
    content: {
      description: `
        <p>Занавеска сделана из плотной непромокаемой ткани, которая называется Дьюспо. Размер изделия в ширину 150 см, а в длину 180 см. Края аккуратно обработаны, а вверху располагаются 11 пластиковых колец, при помощи которых штора крепится.</p>
        <p>Имеется лицевая и изнаночная стороны. Печать полноцветного изображения осуществляется на лицевой стороне, поэтому она гораздо более яркая, нежели изнаночная.</p>
      `
    }
  },
  {
    id: `printing`,
    title: `Способ печати`,
    content: {
      printingInfo: `
        <p>Способ печати - сублимация. Принт становится частью ткани и не чувствуется на ощупь. Картинка получается яркой и сочной. Изображение не стирается, не выцветает и не трескается.</p>
        <p>Можно стирать в машинке.</p>
      `
    }
  },
  {
    id: `price`,
    title: `Цены`
  },
  {
    id: `delivery`,
    title: `Доставка и оплата`
  },
  {
    id: `reviews`,
    title: `Отзывы`
  }
];
